import { get, post } from '../request'

export default {
    /**
   * @description 获取油罐信息
   * @param {Object} params 
   */
    getGaugeList(params) {
        return get("/gauge/list",params)
    },
    
    /**
   * @description 新增油罐信息
   * @param {Object} params 
   */
    addGauge(params) {
        return post("/gauge/add", params)
    },

    /**
   * @description 新增油罐入库记录
   * @param {Object} params 
   */
    addGaugeRecord(params) {
        return post("/gaugeRecord/add", params)
    },

    /**
   * @description 查询油罐入库记录
   * @param {Object} params {canNumber, page, size}
   */
    getGaugeRecordList(params) {
        return get("/gaugeRecord/list", params)
    },

    /**
   * @description 新增油罐盘点记录
   * @param {Object} params 
   */
    addGaugeTakeStock(params) {
        return post("/gaugeTakeStock/add", params)
    },

    /**
   * @description 查询油罐盘点记录
   * @param {Object} params {canNumber, page, size}
   */
    getGaugeTakeStockList(params) {
        return get("/gaugeTakeStock/list", params)
    },

    /**
   * @description 获取油罐班次统计信息
   * @param {Object} params {shiftEndId, shiftStartId}
   */
    getGaugeShiftStatistics(params) {
        return get("/gauge/shiftToStatistics", params)
    },
    delGaugeRecord(params) {
        // console.log('删除油罐出入库记录',params);
        return get(`/gaugeRecord/delete?id=${params.id}`)
    },
    
    /**
   * @description 结束油罐入库
   * @param {Object} params {canNumber}
   */
    endGaugeRecord(params) {
        return get("/gaugeRecord/endRecord", params)
    },

    /**
   * @description 导出油罐记录Excel
   * @param {Object} params {startTime, endTime, canNumber}
   */
    exportGaugeRecord(params) {
        return get("/gaugeRecord/exportByTime", params)
    }
}